import BOOKS_IMAGE from '../images/books.png'
import CHARITY_IMAGE from '../images/charity.png'
import DINING_IMAGE from '../images/dining.png'
import ENTRETAINMENT_IMAGE from '../images/entretainment.png'
import GROCERIES_IMAGE from '../images/groceries.png'
import LIVING_IMAGE from '../images/living.png'
import SOCIAL_IMAGE from '../images/social.png'
import TRANSPOTATION_IMAGE from '../images/transportation.png'
import PROJECTS_IMAGE from '../images/projects.png'

const IMAGES = {
  books: <img src={BOOKS_IMAGE} alt='books' />,
  charity: <img src={CHARITY_IMAGE} alt='charity' />,
  dining: <img src={DINING_IMAGE} alt='dining' />,
  entretainment: <img src={ENTRETAINMENT_IMAGE} alt='entretainment' />,
  groceries: <img src={GROCERIES_IMAGE} alt='groceries' />,
  living: <img src={LIVING_IMAGE} alt='living' />,
  social: <img src={SOCIAL_IMAGE} alt='social' />,
  transportation: <img src={TRANSPOTATION_IMAGE} alt='transportation' />,
  projects: <img src={PROJECTS_IMAGE} alt='projects' />,
  default: <div className='icon'>?</div>
}

export { IMAGES }
